<div class="navbar-area">
    <div class="wilo-responsive-nav">
        <div class="container">
            <div class="wilo-responsive-menu">
                <div class="logo">
                    <a routerLink="/">
                        <img
                            class="udfLogo"
                            src="assets/img/udf.png"
                            alt="logo"
                        />
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="wilo-nav">
        <div class="container-fluid">
            <nav class="navbar navbar-expand-md navbar-light">
                <a class="navbar-brand" routerLink="/">
                    <img class="udfLogo" src="assets/img/udf.png" alt="logo" />
                </a>

                <div class="collapse navbar-collapse mean-menu">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a
                                routerLink="/"
                                class="nav-link"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                >Home</a
                            >
                        </li>
                        <li class="nav-item">
                            <a
                                routerLink="/data-foundation"
                                href="javascript:void(0)"
                                class="nav-link"
                                >Data Foundation &nbsp;<i
                                    class="bx bx-chevron-down"
                                ></i
                            ></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a
                                        routerLink="/data-foundation-governance"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Governance</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/data-foundation-architecture"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Architecture & Modeling</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/kepler-data-ingestion-request-form"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Kepler Data Ingestion Request Form</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/data-foundation-faqs"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >FAQs</a
                                    >
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item">
                            <a
                                routerLink="/platforms"
                                href="javascript:void(0)"
                                class="nav-link"
                                >Platforms &nbsp;<i
                                    class="bx bx-chevron-down"
                                ></i
                            ></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a
                                        routerLink="/platforms-kepler"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Kepler</a
                                    >
                                </li>

                                <li class="nav-item">
                                    <a
                                        routerLink="/platforms-mdp"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >MDP</a
                                    >
                                </li>

                                <li class="nav-item">
                                    <a
                                        routerLink="/platforms-uda"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >UDA</a
                                    >
                                </li>

                                <li class="nav-item">
                                    <a
                                        routerLink="/platforms-osdu"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >OSDU</a
                                    >
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item">
                            <a
                                routerLink="/university"
                                href="javascript:void(0)"
                                class="nav-link"
                                >University &nbsp;<i
                                    class="bx bx-chevron-down"
                                ></i
                            ></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a
                                        href="javascript:void(0)"
                                        class="nav-link"
                                        >Kepler
                                        <i class="bx bx-chevron-right"></i
                                    ></a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item">
                                            <a
                                                routerLink="/university-kepler"
                                                class="nav-link"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                >Introduction to Kepler</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                routerLink="/university-kepler-deeper"
                                                class="nav-link"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                >Deeper Dive - Kepler</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                routerLink="/university-kepler-data-ana"
                                                class="nav-link"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                >Kepler for Data Analysts</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                routerLink="/university-kepler-data-eng"
                                                class="nav-link"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                >Kepler for Data Engineers</a
                                            >
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item">
                                    <a
                                        href="javascript:void(0)"
                                        class="nav-link"
                                        >MDP <i class="bx bx-chevron-right"></i
                                    ></a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item">
                                            <a
                                                routerLink="/university-mdp"
                                                class="nav-link"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                >Introduction to MDP</a
                                            >
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item">
                                    <a
                                        href="javascript:void(0)"
                                        class="nav-link"
                                        >UDA <i class="bx bx-chevron-right"></i
                                    ></a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item">
                                            <a
                                                routerLink="/university-uda"
                                                class="nav-link"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                >Introduction to UDA
                                                (Lakehouse)</a
                                            >
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item">
                                    <a
                                        href="javascript:void(0)"
                                        class="nav-link"
                                        >Technologies
                                        <i class="bx bx-chevron-right"></i
                                    ></a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item">
                                            <a
                                                routerLink="/university-airflow-training"
                                                class="nav-link"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                >Airflow</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                routerLink="/azure-dataexplorer"
                                                class="nav-link"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                >Azure Data Management</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                routerLink="/university-kusto"
                                                class="nav-link"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                >Kusto Query Language</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                routerLink="/openshift-foundation"
                                                class="nav-link"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                >OpenShift</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                routerLink="/university-snowflake"
                                                class="nav-link"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                >Snowflake</a
                                            >
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item">
                                    <a
                                        href="javascript:void(0)"
                                        class="nav-link"
                                        >Data Products<i
                                            class="bx bx-chevron-right"
                                        ></i
                                    ></a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item"><a routerLink="/data-products" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Thoughtsworks Demos</a></li>
                                        <!-- <li class="nav-item"><a routerLink="/azure-dataexplorer" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Azure Data Management</a></li>
                                        <li class="nav-item"><a routerLink="/university-kusto" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Kusto Query Language</a></li>
                                        <li class="nav-item"><a routerLink="/openshift-foundation" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">OpenShift</a></li>
                                        <li class="nav-item"><a routerLink="/university-snowflake" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Snowflake</a></li> -->
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item">
                            <a
                                routerLink="/success-stories"
                                class="nav-link"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                >Success Stories</a
                            >
                        </li>
                        <!-- <li class="nav-item"><a routerLink="/platform-status" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Platform Status</a></li> -->
                        <!-- <li class="nav-item"><a href="javascript:void(0)" class="nav-link">Pages <i class='bx bx-chevron-down'></i></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item"><a routerLink="/case-studies-3-columns" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}"></a></li>

                                <li class="nav-item"><a routerLink="/case-studies-details" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Timeline & Roadmap</a></li>
                            </ul>
                        </li> -->

                        <!-- <li class="nav-item"><a href="javascript:void(0)" class="nav-link">Community of Practice <i class='bx bx-chevron-down'></i></a>
                            <ul class="dropdown-menu">

                                <li class="nav-item"><a routerLink="/gallery" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Feedback</a></li>

                                <li class="nav-item"><a href="javascript:void(0)" class="nav-link">Courses <i class='bx bx-chevron-right'></i></a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item"><a routerLink="/courses" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Courses</a></li>

                                        <li class="nav-item"><a routerLink="/courses-details" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Courses Details</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item"><a href="javascript:void(0)" class="nav-link">Community of Practice <i class='bx bx-chevron-right'></i></a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item"><a routerLink="/events" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Feedback</a></li>

                                        <li class="nav-item"><a routerLink="/events-details" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Contact</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item"><a routerLink="/faq" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">FAQ</a></li>

                                <li class="nav-item"><a routerLink="/error" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">404 Error Page</a></li>

                                <li class="nav-item"><a routerLink="/contact" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Contact</a></li>
                            </ul>
                        </li> -->

                        <li class="nav-item">
                            <a
                                routerLink="/community-of-practice"
                                href="javascript:void(0)"
                                class="nav-link"
                                >Community of Practice &nbsp;<i
                                    class="bx bx-chevron-down"
                                ></i
                            ></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a
                                        routerLink="/UDF-CoP"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >UDF CoP</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/what-is-CoP"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >What is a CoP?</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/benefits-CoP"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Benefits of CoP</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/CoP-Roles"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >CoP Roles & Responsibilities</a
                                    >
                                </li>
                                <!-- <li class="nav-item"><a routerLink="/CoP-Newsletters" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Newsletters</a></li> -->
                                <li class="nav-item">
                                    <a
                                        href="https://ishareteam7.na.xom.com/sites/UDAO/UDF/UDF_Site/index.html#/"
                                        target="_blank"
                                        >Newsletters</a
                                    >
                                </li>
                                <li class="nav-item">
                                    <a
                                        routerLink="/community-of-practice-feedback"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        >Feedback</a
                                    >
                                </li>
                                <!--<li class="nav-item"><a routerLink="/blog-details" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Contact</a></li> -->
                            </ul>
                        </li>
                    </ul>

                    <div class="others-option d-flex align-items-center">
                        <div class="option-item">
                            <form class="search-box" (ngSubmit)="onSubmit()">
                                <input
                                    type="text"
                                    class="input-search"
                                    placeholder="Search for pages"
                                    [(ngModel)]="searchTerm"
                                    name="searchTerm"
                                />
                                <button type="submit">
                                    <i class="flaticon-loupe"></i>
                                </button>
                            </form>
                            <span
                                *ngIf="isSearchTermEmpty() && submitClicked"
                                class="search-box-error"
                                >Please provid a valid term!</span
                            >
                        </div>

                        <!-- <div class="option-item">
                            <a routerLink="/contact" class="default-btn"><i class="flaticon-right"></i>Get Started<span></span></a>
                        </div> -->
                    </div>
                </div>
            </nav>
        </div>
    </div>

    <div class="others-option-for-responsive">
        <div class="container">
            <div class="dot-menu">
                <div class="inner">
                    <div class="circle circle-one"></div>
                    <div class="circle circle-two"></div>
                    <div class="circle circle-three"></div>
                </div>
            </div>

            <div class="container">
                <div class="option-inner">
                    <div class="others-option">
                        <div class="option-item">
                            <form class="search-box" (ngSubmit)="onSubmit()">
                                <input
                                    type="text"
                                    class="input-search"
                                    placeholder="Search for pages"
                                    [(ngModel)]="searchTerm"
                                    name="searchTerm"
                                />
                                <button type="submit">
                                    <i class="flaticon-loupe"></i>
                                </button>
                            </form>
                            <span
                                *ngIf="isSearchTermEmpty() && submitClicked"
                                class="search-box-error"
                                >Please provid a valid term!</span
                            >
                        </div>

                        <!-- <div class="option-item">
                            <a routerLink="/contact" class="default-btn"><i class="flaticon-right"></i>Get Started<span></span></a>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
